<template>
  <v-dialog v-model="dialog" max-width="640" scrollable>
    <v-card v-if="tarjeta" class="movimientos-tarjeta">
      <div class="movimientos-tarjeta__cabecera">
        <v-icon color="white" size="28" class="mr-3">mdi-gift-outline</v-icon>
        <div class="movimientos-tarjeta__titulo">
          <strong>Movimientos de la tarjeta</strong>
          <small>{{ tarjeta.code || "Sin activar" }}</small>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon color="white" title="Cerrar" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </div>

      <v-card-text class="pt-4">
        <div class="movimientos-tarjeta__resumen">
          <div>
            <span>Saldo disponible</span>
            <strong class="movimientos-tarjeta__saldo">{{ $filters.currency(tarjeta.saldo, 0) }}</strong>
          </div>
          <div>
            <span>Valor inicial</span>
            <strong>{{ $filters.currency(tarjeta.amount, 0) }}</strong>
          </div>
          <div>
            <span>Vencimiento</span>
            <strong>{{ tarjeta.expiration_date ? $filters.date(tarjeta.expiration_date) : "Sin vencimiento" }}</strong>
          </div>
        </div>
        <v-alert v-if="tarjeta.no_disponible > 0" dense text type="warning" class="mt-3 mb-0">
          {{ $filters.currency(tarjeta.no_disponible, 0) }} ya no se pueden gastar
          ({{ tarjeta.status === "active" ? "saldo vencido" : "tarjeta cancelada" }}).
        </v-alert>

        <SkeletonLista v-if="cargando" :filas="4" :columnas="3" />
        <p v-else-if="!tarjeta.movimientos.length" class="text-center grey--text mt-6">Todavía no tiene movimientos: la tarjeta no se ha activado.</p>
        <v-timeline v-else dense class="movimientos-tarjeta__linea">
          <v-timeline-item
            v-for="m in movimientosRecientes"
            :key="m.id"
            :color="color(m)"
            small
            fill-dot
          >
            <template v-slot:icon><v-icon x-small color="white">{{ icono(m) }}</v-icon></template>
            <div class="movimientos-tarjeta__fila">
              <div class="movimientos-tarjeta__texto">
                <strong>{{ titulo(m) }}</strong>
                <small>
                  {{ $filters.datetime(m.fecha) }}
                  <template v-if="m.factura"> · Factura {{ m.factura }}</template>
                  <template v-if="m.usuario"> · {{ m.usuario }}</template>
                </small>
              </div>
              <div class="movimientos-tarjeta__valores">
                <strong :class="m.valor < 0 ? 'error--text' : 'success--text'">
                  {{ m.valor < 0 ? "−" : "+" }}{{ $filters.currency(Math.abs(m.valor), 0) }}
                </strong>
                <small>Saldo {{ $filters.currency(m.saldo_despues, 0) }}</small>
              </div>
            </div>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
/** Historial de una tarjeta de regalo: activación, pagos (con su factura) y devoluciones, el más nuevo arriba. */
export default {
  data() {
    return { dialog: false, cargando: false, tarjeta: null };
  },
  computed: {
    movimientosRecientes() {
      return [...this.tarjeta.movimientos].reverse();
    },
  },
  methods: {
    async renderItem(item) {
      this.tarjeta = { code: item.code, saldo: item.saldo || 0, amount: item.amount, expiration_date: item.expiration_date, status: item.status, no_disponible: 0, movimientos: [] };
      this.dialog = true;
      this.cargando = true;
      const res = await this.$http.get("api/v1/gift-card/" + item.id + "/movements", null, false, true);
      this.cargando = false;
      if (res && res.success) {
        this.tarjeta = res.item;
      } else {
        this.dialog = false;
      }
    },
    titulo(m) {
      return { activacion: "Tarjeta activada", pago: "Pago con la tarjeta", devolucion: "Saldo devuelto (nota crédito)" }[m.tipo] || m.tipo;
    },
    icono(m) {
      return { activacion: "mdi-check", pago: "mdi-cart-outline", devolucion: "mdi-undo-variant" }[m.tipo];
    },
    color(m) {
      return { activacion: "success", pago: "error", devolucion: "info" }[m.tipo];
    },
  },
};
</script>

<style scoped>
.movimientos-tarjeta__cabecera {
  display: flex;
  align-items: center;
  padding: 14px 18px;
  background: var(--pos-encabezado);
  color: #fff;
}
.movimientos-tarjeta__titulo {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.movimientos-tarjeta__titulo small {
  font-family: "Courier New", monospace;
  letter-spacing: 1px;
  opacity: 0.95;
}
.movimientos-tarjeta__resumen {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
}
.movimientos-tarjeta__resumen > div {
  display: flex;
  flex-direction: column;
  padding: 10px 14px;
  border-radius: 8px;
  background: #f5f6f8;
}
.movimientos-tarjeta__resumen span {
  font-size: 12px;
  color: #5f6368;
}
.movimientos-tarjeta__saldo {
  font-size: 22px;
  color: #1b5e20;
}
.movimientos-tarjeta__linea {
  margin-top: 8px;
}
.movimientos-tarjeta__fila {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.movimientos-tarjeta__texto,
.movimientos-tarjeta__valores {
  display: flex;
  flex-direction: column;
}
.movimientos-tarjeta__valores {
  text-align: right;
  white-space: nowrap;
}
.movimientos-tarjeta__texto small,
.movimientos-tarjeta__valores small {
  color: #5f6368;
  font-size: 12px;
}
</style>
